module.exports = __webpack_public_path__ + "static/work_BigBang_2023_3D_clip-bcf27edb3ecc21220b9fb2afb8161038.mp4";